"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TopNav = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _ThemeConstant = require("../../constants/ThemeConstant");

var _utils = _interopRequireDefault(require("../../utils"));

var _MenuContent = _interopRequireDefault(require("./MenuContent"));

var TopNav = function TopNav(_ref) {
  var topNavColor = _ref.topNavColor,
      _ref$localization = _ref.localization,
      localization = _ref$localization === void 0 ? true : _ref$localization;
  var props = {
    topNavColor: topNavColor,
    localization: localization
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "top-nav ".concat(_utils.default.getColorContrast(topNavColor)),
    style: {
      backgroundColor: topNavColor
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "top-nav-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_MenuContent.default, Object.assign({
    type: _ThemeConstant.NAV_TYPE_TOP
  }, props))));
};

exports.TopNav = TopNav;

var mapStateToProps = function mapStateToProps(_ref2) {
  var theme = _ref2.theme;
  var topNavColor = theme.topNavColor;
  return {
    topNavColor: topNavColor
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(TopNav);

exports.default = _default;